import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms'
import { Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';

import { UserService } from '../../services/user.service';
import { DomainService } from 'src/app/services/domain.service';

  


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.styles.css']
})
export class LoginComponent implements OnInit {

  public loginForm = this.fb.group({
    email: ['', Validators.email],
    password: ['', Validators.required],
    remember: [false],

  });

  public e="";

  constructor( 
    private fb : FormBuilder, 
    private userService : UserService, 
    private router: Router, 
    private route:ActivatedRoute,
    public domainService: DomainService
  ) {}
  

  ngOnInit(): void {
    if(sessionStorage.getItem('paymentReturn')){
      sessionStorage.removeItem('paymentReturn');
      this.router.navigate(['dashboard/clientEvaluated']);
    }
    var action = this.route.snapshot.queryParamMap.get("action");
    if (action) {
      sessionStorage.setItem("action",action);
    }
    let uid = this.route.snapshot.queryParamMap.get('uid');
    if (uid){
      sessionStorage.setItem("uid",uid);
    }
    this.domainService.inirService();
  }

  login(){
    this.userService.login(this.loginForm.value).subscribe(
      res=>{
        localStorage.setItem('token',res.token);
        // this.loginForm.reset();
        this.userService.user = res.user;
        if (this.userService.user.isCustomBrand) {
          localStorage.setItem('uid', this.userService.user._id);
        }
        if (this.userService.user.role == "admin"){
          localStorage.setItem('role', 'admin');
          this.router.navigate(['dashboard']);
        }else {
          if (this.userService.user.role == "client"){
            this.router.navigate(['dashboard/clientEvaluated']);
          localStorage.setItem('role', 'client');

          }
          if (this.userService.user.role == "evaluated"){
            this.router.navigate(['dashboard/requestedTests']);
          localStorage.setItem('role', 'evaluated');

          }
        }
      },
      err=>{
        Swal.fire('Error',err.error, 'error');
        // this.loginForm.reset();
      }
        )
  }

  campoNoValido(campo:string){
    if (this.loginForm.get(campo).invalid && this.loginForm.get(campo).touched){
      return true;
    }else return false;
  }

  submitNewPassword(){
    this.userService.requestNewPassword(this.e).subscribe(
      resp=>{
        Swal.fire({
          text:'Se ha enviado un email con las instrucciones para recuperar su contraseña a su casilla de email.',
          icon:'info'
        }).then(
          resp=>window.location.reload()
        )
      },
      err=>console.log(err)
    )
  }

}
